import { getAppConfig } from '@client/core/config/get-app-config';

const { assetBaseUrl } = getAppConfig();

/**
 * Returns the full path to the asset.
 * This is used to properly serve the assets.
 */
export function asset(path: string): string {
  // trim leading slash if any
  const trimmedAssetName = path.replace(/^\//, '');

  return `${assetBaseUrl}${trimmedAssetName}`;
}
